import { LegacyGetProfilesCollection } from "PFApp/legacy_cv_export_flow";
import { fetchExportProfiles } from "PFCore/services/export_profiles";
import { Id } from "PFTypes";

// Legacy CV export flow copied from uat, used only when the cv_export_legacy_flow feature flag is ON.
// Meant to be removed together with the flag.
export const getLegacyCvExportProfilesCollection = (profileId: Id) =>
  (() =>
    fetchExportProfiles({
      profileIds: [profileId]
    }).then((resp) => ({
      entries: resp.map((profile) => ({
        profile
      })),
      meta: { total: resp.length, page: 1 }
    }))) as LegacyGetProfilesCollection;
